import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  tableCell: {
    fontSize: '13px',
    border: 'none',
    color: '#000000',
    padding: 0,
    [theme.breakpoints.down('sm')]: {
      fontSize: '11px',
    }
  },
  tableRow: {
    height: '46px',
    [theme.breakpoints.down('sm')]: {
      height: '36px',
    }
  },
  tableHead: {
    height: '36px',
    [theme.breakpoints.down('sm')]: {
      height: '30px',
    }
  },
  tableWrapper: {
    padding: '20px 80px 0px 180px',
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      padding: '10px 20px 40px 20px',
    }
  },
  table: {
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      fontSize: '12px',
      paddingBottom: '30px'
    }
  },
  tableTitle: {
    fontSize: '15px',
    fontWeight: 'bold',
    paddingBottom: '30px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '15px',
      paddingBottom: '20px',
    }
  },
  heading: {
    color: '#717171',
    border: 'none',
    padding: 0,
    fontWeight: 'bold',
    fontSize: '10px',
    fontFamily: 'Fira Sans',
    letterSpacing: '0.035em',
    textTransform: 'uppercase',
    [theme.breakpoints.down('sm')]: {
      fontSize: '8px',
      letterSpacing: '0.03em',
    }
  },
  unitCell: {
    width: '300px',
    paddingRight: '30px',
    [theme.breakpoints.down('sm')]: {
      width: '200px',
      paddingRight: '10px',
    }
  },
  unitTitle: {
    fontWeight: 'bold',
    [theme.breakpoints.down('sm')]: {
      fontSize: '12px',
    }
  },
  slotsNumberCell: {
    width: '120px',
    paddingRight: '20px',
    [theme.breakpoints.down('sm')]: {
      width: '80px',
      paddingRight: '10px',
    }
  }
}));

export default useStyles;

